// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-area-container-N8x99 {
  width: 260px;
}

.text-area-label-bHVee {
  display: block;
  font-size: 14px;
  color: var(--color-neutral-800);
  margin-bottom: 8px;
}

.text-area-input-w244I {
  height: 44px;
  width: 100%;
  display: block;
  font-family: Roboto;
  font-size: 15px;
  resize: none;
  background-color: white;
  border: 1px solid var(--color-neutral-300);
  border-radius: var(--radius-lg);
  outline: none;
  padding: 12px 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.text-area-input-w244I::placeholder {
  font-size: 15px;
  color: var(--color-neutral-500);
}

.text-area-input-w244I:focus {
  border-color: var(--color-neutral-800);
  box-shadow: 0 0 0 0.5px var(--color-neutral-800);
}

.text-area-hint-K7G1i {
  font-size: 13px;
  margin-top: 8px;
  margin-left: 4px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/text-area/text-area.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".container {\n  width: 260px;\n}\n\n.label {\n  display: block;\n  font-size: 14px;\n  color: var(--color-neutral-800);\n  margin-bottom: 8px;\n}\n\n.input {\n  height: 44px;\n  width: 100%;\n  display: block;\n  font-family: Roboto;\n  font-size: 15px;\n  resize: none;\n  background-color: white;\n  border: 1px solid var(--color-neutral-300);\n  border-radius: var(--radius-lg);\n  outline: none;\n  padding: 12px 14px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.input::placeholder {\n  font-size: 15px;\n  color: var(--color-neutral-500);\n}\n\n.input:focus {\n  border-color: var(--color-neutral-800);\n  box-shadow: 0 0 0 0.5px var(--color-neutral-800);\n}\n\n.hint {\n  font-size: 13px;\n  margin-top: 8px;\n  margin-left: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `text-area-container-N8x99`,
	"label": `text-area-label-bHVee`,
	"input": `text-area-input-w244I`,
	"hint": `text-area-hint-K7G1i`
};
export default ___CSS_LOADER_EXPORT___;
